export default {
      id: "icon-alert-usage",
      viewBox: "0 0 94 94",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-alert",
      toString: function () {
        return this.url;
      }
    }